var $window = $(window);
var breakPoint = 1024;

var resizeFlag = false;
var windowWidth = $window.width();
var windowHeight = $window.height();

// メディアクエリ
var mql = window.matchMedia('screen and (max-width: 1024px)');

//ローディング
import {
  loading
} from "../include/module";
loading();

//ヘッダーの開閉
import {
  headerToggle
} from "../include/module";
headerToggle();

//ページ内リンクのアニメーション
import {
  anchorScroll
} from "../include/module";
anchorScroll();

// preload
import {
  preload
} from "../include/module";
preload();

// resizing
import {
  resizing
} from "../include/module";
resizing();

// アニメーション
import {
  animationFire
} from "../include/module";
animationFire();

//モーダル
import {
  closeModal
} from "../include/module";
closeModal();

//YouTubeのモーダル
import {
  youtubeModal
} from "../include/module";
youtubeModal();


/*-------------------------------------------------------------------*/
/* ビジュアルチェンジ */
/*-------------------------------------------------------------------*/
const changeImage = () => {
  $('.js-VisualChange').find('li').eq(0).click(function () {

    const $this = $(this);

    if ($this.hasClass('current')) {
      return false;
    }

    // const index = $('.js-VisualChange').find('li').index(this);
    const $target = $('.index-Mainvisual');

    $target.each(function () {
      $target.fadeOut(200);
      $target.each(function (i) {
        $target.delay(i * 150).queue(() => {
          $target.removeClass('season-final_01').dequeue();
          $target.removeClass('season-final_02').dequeue();
          $target.removeClass('season-final_03').dequeue();
          $target.addClass('season-final_04').dequeue();

        });
      });
      $target.delay(300).fadeIn(300);

      // $target.removeClass('season2_03');
      // $target.addClass('season2_02');
      // $target.delay(200).fadeIn(300);
      $this.addClass('current');
      $('.js-VisualChange').find('li').eq(1).removeClass('current');
      $('.js-VisualChange').find('li').eq(2).removeClass('current');
      $('.js-VisualChange').find('li').eq(3).removeClass('current');
    });
  });
  $('.js-VisualChange').find('li').eq(1).click(function () {

    const $this = $(this);

    if ($this.hasClass('current')) {
      return false;
    }

    // const index = $('.js-VisualChange').find('li').index(this);
    const $target = $('.index-Mainvisual');

    $target.each(function () {
      $target.fadeOut(200);
      $target.each(function (i) {
        $target.delay(i * 150).queue(() => {
          $target.removeClass('season-final_01').dequeue();
          $target.removeClass('season-final_02').dequeue();
          $target.removeClass('season-final_04').dequeue();
          $target.addClass('season-final_03').dequeue();
        });
      });
      $target.delay(300).fadeIn(300);
      $this.addClass('current');
      $('.js-VisualChange').find('li').eq(0).removeClass('current');
      $('.js-VisualChange').find('li').eq(2).removeClass('current');
      $('.js-VisualChange').find('li').eq(3).removeClass('current');
    });
  });
  $('.js-VisualChange').find('li').eq(2).click(function () {

    const $this = $(this);

    if ($this.hasClass('current')) {
      return false;
    }

    // const index = $('.js-VisualChange').find('li').index(this);
    const $target = $('.index-Mainvisual');

    $target.each(function () {
      $target.fadeOut(200);
      $target.each(function (i) {
        $target.delay(i * 150).queue(() => {
          $target.removeClass('season-final_01').dequeue();
          $target.removeClass('season-final_03').dequeue();
          $target.removeClass('season-final_04').dequeue();
          $target.addClass('season-final_02').dequeue();
        });
      });
      $target.delay(300).fadeIn(300);
      $this.addClass('current');
      $('.js-VisualChange').find('li').eq(0).removeClass('current');
      $('.js-VisualChange').find('li').eq(1).removeClass('current');
      $('.js-VisualChange').find('li').eq(3).removeClass('current');
    });
  });
  $('.js-VisualChange').find('li').eq(3).click(function () {

    const $this = $(this);

    if ($this.hasClass('current')) {
      return false;
    }

    // const index = $('.js-VisualChange').find('li').index(this);
    const $target = $('.index-Mainvisual');

    $target.each(function () {
      $target.fadeOut(200);
      $target.each(function (i) {
        $target.delay(i * 150).queue(() => {
          $target.removeClass('season-final_02').dequeue();
          $target.removeClass('season-final_03').dequeue();
          $target.removeClass('season-final_04').dequeue();
          $target.addClass('season-final_01').dequeue();
        });
      });
      $target.delay(300).fadeIn(300);
      $this.addClass('current');
      $('.js-VisualChange').find('li').eq(0).removeClass('current');
      $('.js-VisualChange').find('li').eq(1).removeClass('current');
      $('.js-VisualChange').find('li').eq(2).removeClass('current');
    });
  });
};
changeImage();

// smoke
// const smoke = (target) => {
//   const elm   = document.getElementById(target);
//   let elmWidth = elm.clientWidth;
//   let elmHeight = elm.clientHeight;
//   const app = new PIXI.Application(elmWidth, elmHeight, {transparent : true});
//   elm.appendChild(app.view);
//   app.stage.interactive = true;
//
//   const container = new PIXI.Container();
//   app.stage.addChild(container);
//
//   let smoke;
//   if(windowWidth < 1025){
//     smoke = PIXI.Sprite.fromImage("/wp/wp-content/themes/anime_heros_ultraman/assets/images/sp/index/img_smoke.png");
//   }else{
//     smoke = PIXI.Sprite.fromImage("/wp/wp-content/themes/anime_heros_ultraman/assets/images/common/index/img_smoke.png");
//   }
//   container.addChild(smoke);
//   smoke.width = app.renderer.width;
//   smoke.height = app.renderer.height;
//   smoke.x = 0;
//   smoke.y = app.renderer.height * .5 - smoke.height / 2;
//
//   const displacementSprite = PIXI.Sprite.fromImage('/wp/wp-content/themes/anime_heros_ultraman/assets/images/common/index/displacement_map_repeat.jpg');
//   displacementSprite.texture.baseTexture.wrapMode = PIXI.WRAP_MODES.REPEAT;
//   const displacementFilter = new PIXI.filters.DisplacementFilter(displacementSprite);
//   displacementSprite.x = 0;
//   displacementSprite.y = 0;
//   displacementFilter.padding = 0;
//   displacementFilter.scale.x = app.renderer.width;
//   displacementFilter.scale.y = app.renderer.height;
//
//   app.stage.addChild(displacementSprite);
//
//   smoke.filters = [displacementFilter];
//
//   let moveX = .5;
//   // let moveY = .5;
//
//   app.ticker.add(function() {
//     if(displacementSprite.x > displacementSprite.width){
//   		displacementSprite.x = 0;
//     }
//     // if(displacementSprite.y > displacementSprite.height || displacementSprite.y < 0){
//   	// 	moveY *= -1;
//     // }
//     displacementSprite.x += moveX;
//     // displacementSprite.y += moveY;
//   });
//
//   $(window).on("resize", function () {
//     if (resizeFlag !== false) {
//       clearTimeout(resizeFlag);
//     }
//     resizeFlag = setTimeout(function() {
//       app.renderer.resize(elm.clientWidth, elm.clientHeight);
//       smoke.width = app.renderer.width;
//       smoke.height = app.renderer.height;
//       smoke.x = 0;
//       smoke.y = app.renderer.height * .5 - smoke.height / 2;
//       displacementFilter.scale.x = app.renderer.width;
//       displacementFilter.scale.y = app.renderer.height;
//       // const checkBreakPoint = (mql) => {
//       //   if (mql.matches) {
//       //     // SP
//       //     smoke.width = app.renderer.width;
//       //     smoke.height = app.renderer.height;
//       //     smoke.x = 0;
//       //     smoke.y = app.renderer.height * .5 - smoke.height / 2;
//       //     displacementFilter.scale.x = app.renderer.width;
//       //     displacementFilter.scale.y = app.renderer.height;
//       //   } else {
//       //     // PC
//       //     smoke.width = app.renderer.width;
//       //     smoke.height = app.renderer.height;
//       //     smoke.x = 0;
//       //     smoke.y = app.renderer.height * .5 - smoke.height / 2;
//       //     displacementFilter.scale.x = app.renderer.width;
//       //     displacementFilter.scale.y = app.renderer.height;
//       //   }
//       // }
//       // mql.addListener(checkBreakPoint);
//       // checkBreakPoint(mql);
//     }, 10);
//   });
// };
// smoke('smoke');


// WEBPACK FOOTER //
// ./src/assets/js/index/script.js